import { render, staticRenderFns } from "./Highscores.vue?vue&type=template&id=64d659db&scoped=true"
import script from "./Highscores.vue?vue&type=script&lang=js"
export * from "./Highscores.vue?vue&type=script&lang=js"
import style0 from "./Highscores.vue?vue&type=style&index=0&id=64d659db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d659db",
  null
  
)

export default component.exports